import React from 'react';
import { Link } from "react-router-dom";
import { Field, FieldArray, reduxForm } from 'redux-form';
import { renderField, renderTextArea } from '../../Utils/renderField';
import { validate, validators } from 'validate-redux-form';
import renderEmergencyType from './EmergencyType';
import { validateWhiteSpace } from '../../../../utility/validation';

const Form = (props) => {
    const { handleSubmit, isUpdate, isView } = props;

    return (
        <form name="loginForm" onSubmit={handleSubmit}>
            <div className="d-flex flex-wrap">
                <div className="col-12 col-md-6 form-group">
                    <label htmlFor="code">Código <span className="text-danger">*</span></label>
                    <Field
                        type="number"
                        name="code"
                        label="code"
                        disabled={isView}
                        component={renderField}
                        className="form-control" />
                </div>
                <div className="col-12 col-md-6 form-group">
                    <label htmlFor="name">Nombre <span className="text-danger">*</span></label>
                    <Field
                        type="text"
                        name="name"
                        label="name"
                        disabled={isView}
                        component={renderField}
                        validate={validateWhiteSpace}
                        className="form-control"
                        maxLength={50}
                    />
                </div>
                <div className="col-12 col-md-6 form-group">
                    <label htmlFor="description">Descripción <span className="text-danger">*</span></label>
                    <Field
                        type="text"
                        name="description"
                        label="description"
                        disabled={isView}
                        component={renderTextArea}
                        validate={validateWhiteSpace}
                        className="form-control" />
                </div>
                <div className="col-12 form-group">
                    <h4>Tipos de emergencias</h4>
                </div>
                <FieldArray
                    name="emergency_type_list"
                    component={renderEmergencyType}
                    isView={isView}
                />
                <div className="col-12 d-flex flex-column flex-md-row justify-content-center">
                    <div className="flex-3"></div>
                    <div className='flex-1 d-flex flex-column flex-md-row justify-content-center'>
                        <Link
                            to={'/emergency-types'}
                            className={isView ? 'btn btn-secondary align-self-center px-3 py-3 m-2 w-100' : 'btn btn-danger align-self-center py-3 m-3 w-100'}
                        >
                            {isView ? 'Atras' : 'Cancelar'}
                        </Link>
                        {
                            !isView &&
                            <button
                                type="submit"
                                className="btn btn-success align-self-center py-3 m-3 w-100">
                                {isUpdate ? "Actualizar" : "Crear"}
                            </button>
                        }
                    </div>
                </div>
            </div>
        </form>
    );
};

export default reduxForm({
    form: 'EmergencyForm', // a unique identifier for this form
    validate: (data) => {
        return validate(data, {
            name: validators.exists()('Este campo es requerido'),
            code: validators.exists()('Este campo es requerido'),
        });
    },
    enableReinitialize: true,
})(Form);
